import { render, staticRenderFns } from "./LegalDoc-Bottom.vue?vue&type=template&id=b4e8ad58&"
import script from "./LegalDoc-Bottom.vue?vue&type=script&lang=js&"
export * from "./LegalDoc-Bottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports